/**
 * The HELP_PAGE_LINK is used to redirect the help icons to the specified link
 */
export const HELP_PAGE_LINK = "https://schoolsims.com/support/"